import { ErrorComponentProps } from '@tanstack/react-router'
import { Alert,AlertDescription,AlertTitle } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { AlertCircle,RotateCcw,Home } from "lucide-react"
import { Link } from '@tanstack/react-router'

export function RouteError({ error, reset }: ErrorComponentProps) {
  console.error("Route Error:", error)

  return (
    <div className="flex h-full w-full flex-col items-center justify-center p-8">
      <Alert variant="destructive" className="max-w-2xl">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Failed to load data</AlertTitle>
        <AlertDescription className="mt-2 flex flex-col gap-4">
          <p className="text-sm opacity-90">
            {error instanceof Error ? error.message : "An unexpected error occurred while loading this page."}
          </p>
          <div className="flex items-center gap-4">
            <Button variant="outline" size="sm" onClick={reset}>
              <RotateCcw className="mr-2 h-4 w-4" />
              Retry
            </Button>
            <Button variant="outline" size="sm" asChild>
              <Link to="/">
                <Home className="mr-2 h-4 w-4" />
                Go Home
              </Link>
            </Button>
          </div>
        </AlertDescription>
      </Alert>
    </div>
  )
}
